module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "10Calc.ee714047.webp";